/* eslint-disable no-undef */
import Vue from 'vue';

export default class Model {
    id;
    updated_at;
    created_at;

    /**
     * Get the path on the server where these resources can be found
     * @return string
     */
    static apiPath() {
        throw new Error('Method path() is not overridden.');
    }

    /**
     * Convert this model instance to a deserialized JSON object (i.e. the on-the-wire format)
     * @return object
     */
    toJson() {
        return this;
    }

    /**
     * Convert a deserialized JSON object to a model class
     * @param json
     * @return {Model}
     */
    static fromJson(json) {
        let instance = new this();
        instance.fill(json);
        return instance;
    }

    /**
     * Create a new Model type, that uses the given url as it's API path. This is useful for child resources:
     * @example
     * let PostComment = Comment.makeModel('/post/5/comments')
     * PostComment.collection() // returns all comments on post with id 5
     * @param url
     */
    static makeModel(url) {
        return class extends this {
            static apiPath() {
                return url;
            }
        };
    }

    /**
     * Get a collection of models
     * @param params
     * @returns {Promise}
     */
    static collection(params = null) {
        return Vue.axios.get(this.apiPath(), { params }).then(resp => {
            let data = resp.data;
            let meta = {};
            // For paginated/wrapped data from the API
            if (resp.data.data) {
                data = resp.data.data;
                meta = resp.data.meta;
            }

            let items = data.map(item => this.fromJson(item));
            return { items, meta };
        }).catch(({ status, errors }) => {
            throw { status, errors };
        });
    }

    /**
     * Get a specific document from the api
     * @param id
     * @returns {Promise}
     */
    static document(id) {
        return Vue.axios.get(this.apiPath() + '/' + id).then(resp => {
            let data = resp.data;

            if (data) {
                return this.fromJson(data);
            } else {
                //reject
            }
        }).catch(({ status, errors }) => {
            throw { status, errors };
        });
    }

    /**
     * Fill the properties of this object with values from another object
     * @param object
     */
    fill(object) {
        for (let prop of Object.getOwnPropertyNames(object)) {
            // Don't copy magic properties (e.g. the Vue observer)
            if (prop.startsWith('__'))
                continue;

            // this[prop] = object[prop];
            // fill props in a Vue-aware reactive way.
            Vue.set(this, prop, object[prop]);
        }

        return this;
    }

    clone(object) {
        return this.assign(this.create(this.getPrototypeOf(object)), object);
    }

    create() {
        return Vue.axios.post(this.constructor.apiPath(), this.toJson()).then(resp => {
            this.id = resp.data.id;
            return this;
        }).catch(({ status, errors }) => {
            throw { status, errors };
        });
    }

    update(fields = null) {
        this.updated = new Date().getTime();

        let path = this.constructor.apiPath() + '/' + this.id;
        let data = fields ? fields : this.toJson();
        return Vue.axios.patch(path, data).then(resp => {
            return this;
        }).catch(({ status, errors }) => {
            throw { status, errors };
        });
    }

    remove() {
        let path = this.constructor.apiPath() + '/' + this.id;
        return Vue.axios.delete(path).then(resp => {
            return this;
        }).catch(({ status, errors }) => {
            throw { status, errors };
        });
    }

    save() {
        return this.id ? this.update() : this.create();
    }
}



// WEBPACK FOOTER //
// ./src/models/Model.js